const TRUCK_TYPES = [
  //TODO: might have some direct freight only types. Remove and add all truckstop types.
  { value: "V", label: "Van" },
  { value: "F", label: "Flatbed" },
  { value: "R", label: "Reefer" },
  { value: "SV", label: "Box Truck" },
  { value: "SD", label: "Step Deck" },
  { value: "DD", label: "Double Drop" },
  { value: "LB", label: "Lowboy" },
  { value: "RGN", label: "Removable Gooseneck" },
  { value: "TNK", label: "Tanker" },
  { value: "AC", label: "Auto Carrier" },
  { value: "CONT", label: "Container" },
  { value: "DT", label: "Dump Truck" },
  { value: "HB", label: "Hopper Bottom" },
  { value: "PO", label: "Power Only" },
  { value: "HS", label: "Hot Shot" },
];

export default TRUCK_TYPES;
